import { Injectable } from '@angular/core';
import { loadStripe, PaymentIntentResult, Stripe } from '@stripe/stripe-js';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class StripeService {
  private stripe: Stripe | null = null;

  constructor(private http: HttpClient) {}
  

  private async initializeStripe(): Promise<void> {
    if (!this.stripe) {
      this.stripe = await loadStripe(environment.stripePublicKey);
    }
  }

  async getStripe(): Promise<Stripe | null> {
    if (!this.stripe) {
      await this.initializeStripe();
    }
    return this.stripe;
  }

  async confirmPayment(
    clientSecret: string,
    cardElement: any,
    saveCard: boolean
  ): Promise<PaymentIntentResult> {
    if (!this.stripe) throw new Error('Stripe is not loaded');

    return this.stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement
      },
      setup_future_usage: saveCard ? 'off_session' : undefined // For saving card
    });
  }

  getCards(): Observable<any> {
    return this.http.get(`${environment.base_url}user/getCard`);
  }

  deleteCard(id: string): Observable<number> {
    return this.http
      .delete<{
        statusCode: number;
      }>(`${environment.base_url}user/deleteCard/${id}`)
      .pipe(map(res => res.statusCode));
  }
}
